module.exports = __webpack_public_path__ + "static/img/hangpai_0111.a3c678e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hangpai_0111.png
// module id = QKQD
// module chunks = 1